import Wrapper from '../layout/wrapper';
import HomeMain from '../components/home';
import SEO from '../components/seo';
import CookieConsent from "react-cookie-consent";

const Home = () => {

  return (
    <Wrapper>
      <SEO pageTitle={'Redação Online'} />
      <HomeMain/>
      <CookieConsent
  location="bottom"
  buttonText="Concordo"
  cookieName="myAwesomeCookieName2"
  style={{ background: "#2B373B" }}
  buttonStyle={{ color: "#fff", background: "#8007e6", fontSize: "16px" }}
  expires={150}
>Usamos cookies para melhorar sua experiência, personalizar publicidade e recomendar conteúdo do seu interesse. Ao clicar em "Concordo", você concorda com os Termos de uso do Site.
</CookieConsent>
    </Wrapper>
  );
};

export default Home;